<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        Assign by Candidate
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" [mat-dialog-close]="null" [disabled]="isSaving">
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
    Please select the new Experience Manager and/or Specialist you wish to apply to the selected {{ candidateIds?.length | i18nPlural: candidateTextMap }}
    <br>
    <br>
    <div class="container">
        <div>
            <div class="form-field" [style.width.%]="100">
                <nova-autocomplete
                    [inputClass]="'nova__input--full-width'"
                    [items]="managers$ | async"
                    itemKey="userId"
                    [hidePopupAfterSelection]="true"
                    [placeholder]="'Select an Experience Manager'"
                    [displayItemFn]="employeeDisplay"
                    [value]="manager?.name"
                    [loading]="managersLoading"
                    dataQaId="TravelXAssignByCandidateManagerAutocomplete"
                    (itemSelected)="selectEmployee($event, 'manager')"
                    (textUpdated)="listEmployees($event, 'manager')"
                    (clearedText)="clearEmployee('manager')">
                </nova-autocomplete>
            </div>
        </div>

        <div>
            <div class="form-field" [style.width.%]="100">
                <nova-autocomplete
                    [inputClass]="'nova__input--full-width'"
                    [items]="specialists$ | async"
                    itemKey="userId"
                    [hidePopupAfterSelection]="true"
                    [placeholder]="'Select an Experience Specialist'"
                    [displayItemFn]="employeeDisplay"
                    [value]="specialist?.name"
                    [loading]="specialistsLoading"
                    dataQaId="TravelXAssignByCandidateSpecialistAutocomplete"
                    (itemSelected)="selectEmployee($event, 'specialist')"
                    (textUpdated)="listEmployees($event, 'specialist')"
                    (clearedText)="clearEmployee('specialist')">
                </nova-autocomplete>
            </div>
        </div>
    </div>
    <mat-dialog-actions class="nova__dialog__content__actions">
        <button data-qa-id="TravelXAssignByCandidateSaveButton" mat-raised-button color="primary" [disabled]="!canSubmit || isSaving"
            (click)="assignByCandidate()">
            <span *ngIf="isSaving"> <mat-progress-spinner color="primary" mode="indeterminate" diameter="13"></mat-progress-spinner> Saving...</span>
            <span *ngIf="!isSaving">SUBMIT CHANGES</span>
        </button>
        <button data-qa-id="TravelXAssignByCandidateCancelButton" mat-raised-button color="default" [mat-dialog-close]="null"
            [disabled]="isSaving">
            CANCEL
        </button>
    </mat-dialog-actions>
</div>
